export default __webpack_public_path__ + "static/media/ref-icon.b655ddb9.svg";